import React from "react";
import "./Pagina.css";
import "./FormStyles.css";
import Contatti from "./Contatti";

const Form = () => {
  return (
    <div className="pagina">
      <div className="pagina-inner">
        <div className="pagina-testo">
          <h1 className="pagina-titolo">CONTATTI</h1>
          <p>
            Compila il form qui accanto, oppure scrivimi direttamente via mail o
            su Instagram dai link in fondo.
          </p>
        </div>

        <div className="pagina-form">
          <Contatti />
        </div>
      </div>
    </div>
  );
};

export default Form;
